import type { ReactNode } from 'react';
import {
  formatChairs,
  formatExhibitDays,
  formatPower,
  formatTables,
  hallOfBooths2026,
  type KioskExhibitor,
} from '@nt-tokyo/shared';

// 受付端末で出展者を表示するカード。出すのは公開してよい情報だけ
// (出展者名・配置番号・号館・出展者番号・出展日・机・椅子・電源)。
// compact: 日曜の画面 (上部に大きな案内が出て縦が詰まる) 用に少し小さくする
export default function ExhibitorCard({
  exhibitor,
  compact = false,
  children,
}: {
  exhibitor: KioskExhibitor;
  compact?: boolean;
  children?: ReactNode;
}) {
  const hall = hallOfBooths2026(exhibitor.boothNumbers);
  // 支払い前・キャンセル済みはサーバが名前と配置番号を伏せて返す。番号だけ出す
  if (!exhibitor.exhibitorName) {
    return (
      <div className={`flex flex-col rounded-2xl border-2 border-[#1f4fd6] bg-white px-5 ${compact ? 'py-2' : 'py-3'}`}>
        <div className="text-[26px] font-extrabold text-[#1d1d1f]">出展者番号 {exhibitor.applicationNumber}</div>
        {children}
      </div>
    );
  }
  return (
    <div className={`flex flex-col rounded-2xl border-2 border-[#1f4fd6] bg-white px-5 ${compact ? 'gap-0.5 py-2' : 'gap-1 py-3'}`}>
      <div className="flex flex-wrap items-baseline gap-x-3">
        <span className={`${compact ? 'text-[28px]' : 'text-[34px]'} font-extrabold leading-tight text-[#1f4fd6]`}>
          {exhibitor.boothNumbers.length > 0 ? exhibitor.boothNumbers.join(', ') : '配置未定'}
        </span>
        {hall && <span className="text-[22px] font-bold text-[#1d1d1f]">{hall}</span>}
      </div>
      <div className={`${compact ? 'text-[22px]' : 'text-[26px]'} font-extrabold leading-snug text-[#1d1d1f]`}>
        {exhibitor.exhibitorName}
      </div>
      <div className="text-[16px] text-[#6b6b70]">
        出展者番号 {exhibitor.applicationNumber} ／ {formatExhibitDays(exhibitor.exhibitDays)}
      </div>
      <EquipmentTags exhibitor={exhibitor} />
      {children}
    </div>
  );
}

export function EquipmentTags({ exhibitor, large = false }: { exhibitor: KioskExhibitor; large?: boolean }) {
  const tags = [
    formatTables(exhibitor.tableCount),
    formatChairs(exhibitor.chairCount),
    formatPower(exhibitor.powerWatts),
  ];
  return (
    <div className="mt-1 flex flex-wrap gap-2">
      {tags.map((t) => (
        <span
          key={t}
          className={
            large
              ? 'rounded-xl border-2 border-[#b9dcc6] bg-white px-4 py-1.5 text-[26px] font-extrabold text-[#1d1d1f]'
              : 'rounded-lg bg-[#f1f1f4] px-2.5 py-0.5 text-[18px] font-bold text-[#1d1d1f]'
          }
        >
          {t}
        </span>
      ))}
    </div>
  );
}
